module.exports = __webpack_public_path__ + "img/15.021ac4e7.png";